const mutations = {
  getNewUserPromos: (state, user_promo) => {
    state.user_promo = user_promo;
  },
  getNewUserPromo: (state, user_promo_id) => {
    state.user_promo_id = user_promo_id;
  },
  getDimension: (state, dimension) => {
    state.dimension = dimension;
  },
  getAdminhub: (state, Adminhub) => {
    state.Adminhub = Adminhub;
  },
  getDiscountType: (state, dicountType) => {
    state.dicountType = dicountType;
  },
  getAddon: (state, Addon) => {
    state.Addon = Addon;
  },
  getExtraPackaging: (state, ExtraPackaging) => {
    state.ExtraPackaging = ExtraPackaging;
  },
  getNewUserAvailability: (state, newuser_availability) => {
    state.newuser_availability = newuser_availability;
  },
  postNewUserPromo: (state, new_user_promo) => {
    state.user_promo.push(new_user_promo);
  },
  updateStatusNewUserPromos: (state, new_status) => {
    state.user_promo = state.user_promo.map((user_promo) => {
      if (user_promo.id === new_status.new_user_promo_id) {
        return Object.assign({}, user_promo, new_status.status);
      }
      return user_promo;
    });
  },
  putNewUserPromo: (state, payload) => {
    state.user_promo = state.user_promo.map((user_promo) => {
      if (user_promo.id === payload.id) {
        return Object.assign({}, user_promo, payload.formData);
      }
      return user_promo;
    });
  },
  delNewUserPromo(state, id) {
    const index = state.user_promo.findIndex(user_promo => user_promo.id == id);
    state.user_promo.splice(index, 1);
  },
};

export default mutations;
